<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const propertyTypeOptions = [
        `Appartement`,
        `Maison / Villa`,
        `Terrain`,
        `Bureau ou local commercial`,
        `Autre (précisez plus bas)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const objectiveOptions = [
        `Acheter`,
        `Louer`,
        `Investir`,
        `Construire / faire construire`,
        `Vendre un bien`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.immobilier.propertyType}
        class=""
        let:field
        let:id
        label={`Quel type de bien recherchez-vous ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={propertyTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.immobilier.objective}
        class=""
        let:field
        let:id
        label={`Quel est votre objectif ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={objectiveOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation souhaitée, type de bien précis, votre budget approximatif…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation souhaitée, type de bien précis, votre budget approximatif…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
